import { Navigate, Outlet } from "react-router-dom";

import { useIsAdmin } from "@/hooks/useIsFinancialManager";

// 어드민 전용 라우트 가드
export function AdminGuard() {
  const isAdmin = useIsAdmin();

  if (!isAdmin) {
    return <Navigate to="/404" replace />;
  }

  return <Outlet />;
}
